export function _causedByOptions() {
    return String('缸体制造,定子制造,转子制造,动平衡,管路成套,核心组装,试验中心,物流部,采购部,订单管理(OM),' +
        '生产计划(PP),数字化运营部(DO),工程部 TC,工程部 辅机,工程部 北京主机,工程部 Recip.主机,工程部 Recip.辅机,DBG Design,' +
        'DBG,GLZ Design,GLZ,Brno Design,Brno,IST 工程,IST 采购,设备维修,质量部,SITH,服务部,本地化,项目管理(PM),' +
        '其他,待定').split(',');
}